<template>
  <div>
    <div class="row">
      <div class="col-12 col-md-6 flexben-page-title">
        <h1>{{ $t("flexben.discount.title") }}</h1>
        <p>{{ $t("flexben.discount.description") }}</p>
      </div>
    </div>

    <div class="container-bg-white">
      <div class="row p-3">
        <div class="col-12 col-xl-3 mb-2 mb-xl-0">
          <img src="@/assets/images/filter.svg" />
          <span class="ml-3">{{ $t("flexben.general.filter") }}</span>
        </div>
        <div class="col-12 col-xl-9">
          <div class="row">
            <!-- Iterează peste filters și renderizează componenta SelectFilter -->
            <div class="col-md-4 form-group">
              <label for="legislated_type" class="col-form-label pt-0">{{ filters.brand.label }}</label>
              <select class="form-control"  id="brand"
                      v-model="filters.brand.selected"
                      @change="applyFilters()">
                <option :value="null">-</option>
                <option v-for="brand in filters.brand.options" :key="brand" :value="brand.id">
                  {{brand.name}}
                </option>
              </select>
            </div>
            <div class="col-md-4 form-group">
              <label for="legislated_type" class="col-form-label pt-0">{{ filters.provider.label }}</label>
              <select class="form-control"  id="provider"
                      v-model="filters.provider.selected"
                      @change="applyFilters()">
                <option :value="null">-</option>
                <option v-for="provider in filters.provider.options" :key="provider" :value="provider">
                  {{provider.name}}
                </option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container-bg-white mt-3">
      <div class="row p-3">
        <div class="col-12">
          <table :id="table.id" class="display table table-hover dataTable swal-datatable" :data-columns='JSON.stringify(table.header)'>
          </table>
        </div>
      </div>

    </div>
    <content-loader :loader-visible="this.loading" :loader-error="loaderError"></content-loader>
    <div v-if="logsModal.visible" class="fb-modal-backdrop" @click.self="closeLogsModal">
      <div class="fb-modal">
        <div class="fb-modal__header">
          <h4 class="m-0">Logs</h4>
          <button class="fb-modal__close" @click="closeLogsModal" aria-label="Close">×</button>
        </div>

        <div class="fb-modal__body" ref="logsScroller">
          <div v-if="logsModal.loading" class="py-3">Se încarcă…</div>
          <div v-else-if="logsModal.error" class="alert alert-danger">{{ logsModal.error }}</div>

          <template v-else>
            <div v-if="!logsModal.items.length" class="text-muted">Nu există log-uri.</div>

            <div v-else class="timeline">
              <div v-for="(log, i) in logsModal.items" :key="i" class="timeline-item">
                <div class="timeline-marker"></div>
                <div class="timeline-content">
                  <time class="timeline-time">{{ formatDate(log.created_at) }}</time>
                  <p class="timeline-text">{{ log.description }}</p>
                </div>
              </div>
            </div>
          </template>
        </div>

        <div class="fb-modal__footer">
          <button class="btn btn-secondary" @click="closeLogsModal">Close</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DataTable from "datatables.net-dt";
import i18n from "@/plugins/language/i18n";
import HttpTreeService from "@/superUp-module/resources/services/httpTreeService";
import ApiHelper from "@/multiben-module/src/services/helper/apiHelper";
import httpFlexben from "@/http/http-flexben";

export default {
  name: "FlexBenDiscounts",

  components: {
    // SelectFilter,
  },

  data() {
    return {
      logsModal: {
        visible: false,
        loading: false,
        error: null,
        items: [],
      },
      loading: false,
      loaderError: false,
      refreshTable: false,
      datatable: null,
      table: {
        id: 'discountTableID',
        ajax: `${ApiHelper.getBaseUrl('v1')}${httpFlexben.discount.discountPathPrefix}/list`,
        header: [
          { title: this.th('flexben.discount.table.provider', 'flexben.discount.table.tooltips.provider'),                 name: 'provider',  data: 'provider',  orderable: false },
          { title: this.th('flexben.discount.table.brand',    'flexben.discount.table.tooltips.brand'),                    name: 'brand',     data: 'brand',     orderable: false },
          { title: this.th('flexben.discount.table.benefit_name','flexben.discount.table.tooltips.benefit_name'),          name: 'benefit',   data: 'benefit',   orderable: false },
          { title: this.th('flexben.discount.table.type','flexben.discount.table.tooltips.type'),          name: 'type',   data: 'type',   orderable: false },
          { title: this.th('flexben.discount.table.full_price','flexben.discount.table.tooltips.full_price'),              name: 'full_price',data: 'full_price',orderable: false },

          { title: this.th('flexben.discount.table.discount.total','flexben.discount.table.tooltips.discount.total'),        name: 'total_value', data: 'total_value', orderable: false },
          { title: this.th('flexben.discount.table.discount.user_value','flexben.discount.table.tooltips.discount.user_value'),        name: 'user_value', data: 'user_value', orderable: false },
          { title: this.th('flexben.discount.table.discount.platform_fee_value','flexben.discount.table.tooltips.discount.platform_fee_value'),        name: 'platform_fee_value', data: 'platform_fee_value', orderable: false },
          { title: this.th('flexben.discount.table.discount.calculator','flexben.discount.table.tooltips.discount.calculator'),        name: 'calculator', data: 'calculator', orderable: false },
          { title: this.th('flexben.discount.table.actions','flexben.discount.table.tooltips.actions'),                     name: 'actions',   data: 'actions',   orderable: false }
        ]
      },
      filters: {
        brand: {
          selected: null,
          label: 'Filter By Brand',
          options: []
        },
        provider: {
          selected: null,
          label: 'Filter By Provider',
          options: []
        }
      }
    }
  },

  methods: {
    applyFilters() {
      if (this.datatable) {
        this.datatable.ajax.reload(null, true);
      }
    },

    resetFilters() {
      this.selectedBrand = null;
      this.selectedProvider = null;
      this.applyFilters();
    },


    openLogsModal(id) {
      this.logsModal.visible = true;
      this.logsModal.loading = true;
      this.logsModal.error = null;
      this.logsModal.items = [];

      httpFlexben.discount.logs(id)
        .then(({ data }) => {
          const arr = Array.isArray(data) ? data : [];
          this.logsModal.items = arr.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
        })
        .catch(() => { this.logsModal.error = 'Nu s-au putut încărca log-urile.'; })
        .finally(() => { this.logsModal.loading = false; this.$nextTick(() => { const scroller = this.$refs.logsScroller; if (scroller) scroller.scrollTop = 0; }); });
    },

    closeLogsModal() {
      this.logsModal.visible = false;
    },

    formatDate(value) {
      if (!value) return '';
      try {
        const d = new Date(value);
        const pad = (n) => String(n).padStart(2, '0');
        return `${d.getFullYear()}-${pad(d.getMonth()+1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
      } catch (e) {
        return String(value);
      }
    },
    escapeHtml(str) {
      return String(str).replace(/[&<>"']/g, s => ({
        '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'
      }[s]));
    },
    th(labelKey, tooltipKey) {
      const label = this.$t(labelKey);
      const tip = this.$t(tooltipKey) || "";
      // HTML în header: text scurt + icon info, tooltip pe title
      return `
      <span class="th-wrap" title="${this.escapeHtml(tip)}" aria-label="${this.escapeHtml(tip)}">
        ${this.escapeHtml(label)}
        <i class="fa fa-info-circle ml-1" aria-hidden="true"></i>
      </span>
    `;
    },

    initTable() {
      this.loading = true
      const instance = this;

      this.datatable = new DataTable(`#${this.table.id}`, {
        serverSide: true,
        autoWidth: false,
        searching: true,
        responsive: true,
        search: {
          return: true
        },
        lengthMenu: [ 15, 25, 50 ],
        ajax: {
          beforeSend: function(request) {
            request.setRequestHeader("X-Up-Language", i18n.locale);
            request.setRequestHeader("Authorization", `Barier ${HttpTreeService.getToken()}`);
            request.setRequestHeader("Content-Type", "application/json;charset=utf-8");
          },
          url: this.table.ajax,
          data: (data) => {
            return {
              ...data,
              filters: [],
              brand_id: this.filters.brand.selected,
              provider_id: this.filters.provider.selected,
            };
          }
        },
        pagingType: "full_numbers",
        processing: false,
        drawCallback: () => {
          this.loading = false;
        },
        createdRow: function (row, data) {
          const type = data.type; //FIXED or PERCENT

          const feeInput = row.querySelector('input.platform_fee_value');
          const userValueDiv = row.querySelector('div.user_value');
          const platformFeePriceDiv = row.querySelector('div.platform_fee_price');

          const totalFromDiscountPriceEl = row.querySelector('.total_from_discount_price');
          const amountFromUserPriceEl = row.querySelector('.amount_from_user_discount_price');
          const amountFromPlatformPriceEl = row.querySelector('.amount_from_platform_fee_discount_price');
          const userDisplayPriceEl = row.querySelector('.user_display_price');

          const fullPrice = parseFloat(data.full_price) || 0;
          const totalPercent = parseFloat(data.total_value) || 0;

          const logsBtn = row.querySelector('button[data-action="action_logs"]');
          if (logsBtn && !logsBtn.dataset.listenerBound) {
            logsBtn.dataset.listenerBound = '1';
            logsBtn.addEventListener('click', function () {
              const id = logsBtn.getAttribute('data-item');
              instance.openLogsModal(id);
            });
          }

          const fmtRON = (n) => `${(Number.isFinite(n) ? n : 0).toFixed(2)} RON`;
          if (type === 'FIXED ') {
            const recalc = () => {
              var fee = 0;
              if (feeInput && feeInput.value !== '' && !isNaN(parseFloat(feeInput.value))) {
                fee = parseFloat(feeInput.value);

                if (fee > totalPercent) {
                  fee = totalPercent;
                  if (feeInput) feeInput.value = String(totalPercent);
                }
                if (fee < 0) {
                  fee = 0;
                  if (feeInput) feeInput.value = '0';
                }

                const amountFromUser = totalPercent - fee;
                userValueDiv.textContent = amountFromUser.toFixed(2);

                if (userDisplayPriceEl) userDisplayPriceEl.textContent = `${(fullPrice - amountFromUser).toFixed(2)} RON`;
              }
            }

            recalc();

            if (feeInput) {

              feeInput.addEventListener('input', recalc);
              feeInput.addEventListener('change', recalc);
            }

            const saveBtn = row.querySelector('button[data-action="action_save"]');
            if (saveBtn && !saveBtn.dataset.listenerBound) {
              saveBtn.dataset.listenerBound = '1'; // evităm multiple attach-uri la redraw

              saveBtn.addEventListener('click', async () => {
                const id = saveBtn.getAttribute('data-item');
                const feePercent = feeInput && feeInput.value !== '' ? parseFloat(feeInput.value) : 0;

                const payload = {
                  id: id,
                  platform_fee_value: feePercent,
                };

                instance.loading = true;
                httpFlexben.discount.save(payload).then(res => {
                  instance.loading = false;
                }).catch(err => {
                  instance.loading = false;
                  instance.loaderError = true;
                })
              });
            }

            return;
          }

          if (totalFromDiscountPriceEl) {
            const totalDiscountedPrice = fullPrice - (fullPrice * (totalPercent / 100));
            totalFromDiscountPriceEl.textContent = fmtRON(totalDiscountedPrice);
          }

          const recalc = () => {
            var feePercent = 0;
            if (feeInput && feeInput.value !== '' && !isNaN(parseFloat(feeInput.value))) {
              feePercent = parseFloat(feeInput.value);
            }

            if (feePercent > totalPercent) {
              feePercent = totalPercent;
              if (feeInput) feeInput.value = String(totalPercent);
            }
            if (feePercent < 0) {
              feePercent = 0;
              if (feeInput) feeInput.value = '0';
            }

            const userPercent = totalPercent - feePercent;
            if (userValueDiv) userValueDiv.textContent = userPercent.toFixed(2);

            const amountFromUser = fullPrice * (userPercent / 100);
            const amountFromPlatform = fullPrice * (feePercent / 100);

            if (platformFeePriceDiv) platformFeePriceDiv.textContent = `${amountFromPlatform.toFixed(2)} RON`;
            if (amountFromUserPriceEl) amountFromUserPriceEl.textContent = `${amountFromUser.toFixed(2)} RON`;
            if (amountFromPlatformPriceEl) amountFromPlatformPriceEl.textContent = `${amountFromPlatform.toFixed(2)} RON`;

            if (userDisplayPriceEl) userDisplayPriceEl.textContent = `${(fullPrice - amountFromUser).toFixed(2)} RON`;
          };

          recalc();

          if (feeInput) {
            feeInput.addEventListener('input', recalc);
            feeInput.addEventListener('change', recalc);
          }

          const saveBtn = row.querySelector('button[data-action="action_save"]');
          if (saveBtn && !saveBtn.dataset.listenerBound) {
            saveBtn.dataset.listenerBound = '1'; // evităm multiple attach-uri la redraw

            saveBtn.addEventListener('click', async () => {
              const id = saveBtn.getAttribute('data-item');
              const feePercent = feeInput && feeInput.value !== '' ? parseFloat(feeInput.value) : 0;

              const payload = {
                id: id,
                platform_fee_value: feePercent,
              };

              instance.loading = true;
              httpFlexben.discount.save(payload).then(res => {
                instance.loading = false;
              }).catch(err => {
                instance.loading = false;
                instance.loaderError = true;
              })
            });
          }
        },
        columns: instance.table.header
      });
    }
  },

  mounted() {
    if (!document.getElementById('font-awesome-cdn')) {
      const link = document.createElement('link');
      link.id = 'font-awesome-cdn'; // Assign an ID to check existence
      link.rel = 'stylesheet';
      link.href = 'https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.0.0-beta3/css/all.min.css';
      document.head.appendChild(link);
    }

    httpFlexben.discount.getFilters().then(({ data }) => {
      this.filters.provider.options = data.providers;
      this.filters.brand.options = data.brands;
      this.initTable();
    })
  },

  watch: {
    refreshTable: function (val) {
      if (val) {
        this.loading = true;
        this.datatable.destroy();
        this.datatable = null;
        this.initTable();
      }
    },
  }
}
</script>
<style lang="css">
.fb-modal-backdrop {
  position: fixed; inset: 0; background: rgba(0,0,0,.5);
  display: flex; align-items: center; justify-content: center;
  z-index: 1050;
}
.fb-modal {
  background: #fff; border-radius: 8px; max-width: 720px; width: 100%;
  box-shadow: 0 10px 30px rgba(0,0,0,.2); overflow: hidden;
}
.fb-modal__header, .fb-modal__footer { padding: 12px 16px; background: #f8f9fa; }
.fb-modal__body { padding: 16px; max-height: 70vh; overflow: auto; }
.fb-modal__close { background: transparent; border: 0; font-size: 24px; line-height: 1; }

/* Timeline */
.timeline {
  position: relative;
  margin-left: 18px;
  padding-left: 16px;
}
.timeline::before {
  content: ""; position: absolute; left: 0; top: 0; bottom: 0;
  width: 2px; background: #e3e6ea;
}
.timeline-item { position: relative; margin-bottom: 16px; }
.timeline-marker {
  position: absolute; left: -7px; top: 6px;
  width: 12px; height: 12px; border-radius: 50%;
  background: #0d6efd; box-shadow: 0 0 0 4px #fff;
}
.timeline-content { padding-left: 8px; }
.timeline-time { display: block; font-size: 12px; color: #6c757d; margin-bottom: 2px; }
.timeline-text { margin: 0; line-height: 1.4; word-break: break-word; }
</style>
